import { render, staticRenderFns } from "./GlassTypeForm.vue?vue&type=template&id=28b6a377&"
import script from "./GlassTypeForm.vue?vue&type=script&lang=js&"
export * from "./GlassTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./GlassTypeForm.vue?vue&type=style&index=0&id=28b6a377&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports